import {Component, effect, inject, OnDestroy} from '@angular/core';
import {WeatherWidgetComponent} from "src/app/presentation/common/weather-widget/weather-widget.component";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {FarmReference} from "src/app/infrastructure/moovement-api/models/farm";
import {
  LoadingPlaceholderComponent
} from "src/app/presentation/common/loading-placeholder/loading-placeholder.component";
import {NgClass} from "@angular/common";
import {Subject, takeUntil} from "rxjs";
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {Router} from '@angular/router';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {
  FarmGeometryComponent
} from "src/app/presentation/main-view/information-center/current-farm/farm-geometry/farm-geometry.component";
import {RefreshStore} from 'src/app/infrastructure/init/refresh/refresh.store';
import {Metadata} from "src/app/presentation/main-view/information-center/current-farm/metadata/metadata";
import {DeviceType} from "src/app/domain/devices/device";
import {DeviceStore} from "src/app/domain/devices/device.store";
import {DeviceAssociationStore} from "src/app/domain/devices/device-association.store";
import {AnimalsStore} from "src/app/domain/assets/animals/animals.store";

@Component({
  selector: 'app-current-farm',
  imports: [
    WeatherWidgetComponent,
    LoadingPlaceholderComponent,
    NgClass,
    FarmGeometryComponent,
    Metadata
  ],
  templateUrl: './current-farm.component.html',
  styleUrl: './current-farm.component.css'
})
export class CurrentFarmComponent implements OnDestroy {

  destroy$ = new Subject<void>();
  farms: FarmReference[] = []
  lastRefresh: string = 'never'

  farmStore = inject(FarmStore);
  refreshStore = inject(RefreshStore);
  deviceStore = inject(DeviceStore);
  deviceAssociationStore = inject(DeviceAssociationStore);
  animalStore = inject(AnimalsStore);

  private router = inject(Router);

  constructor(dataSubscriptionService: DataSubscriptionService) {
    effect(() => {
      this.lastRefresh = timeAgo(this.refreshStore.lastRefresh());
    });

    dataSubscriptionService.onNext<FarmReference[]>('farmReferences').pipe(takeUntil(this.destroy$)).subscribe({
      next: farmReferences => {
        this.farms = farmReferences;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  open(url: string): void {
    if (this.farms.length <= 1) return;
    this.router.navigate([url]);
  }

  protected hasNFCTags() {
    return true;
    const assetIds = this.animalStore.entities().map(entity => entity.id)
    return assetIds.some(assetId => {
      const deviceAssociations = this.deviceAssociationStore.assetIdToAssocations().get(assetId)
      const deviceId = deviceAssociations?.at(0)?.deviceId;
      if (deviceId == undefined) return false;
      const deviceType = this.deviceStore.deviceIdToType().get(deviceId!);
      return deviceType === DeviceType.NFC_TAG;
    })
  }
}
